import _ from 'lodash';
import { INIT_ROOT } from '../actionTypes';

const isLite = (renderMode) => renderMode === 'LITE';

export default function features(state, { type, payload }) {
  const defaultRenderSettings = {
    disableNotifications: false,
    disablePostalCode: false,
    disableInventorySummary: false,
    disableCompareTrims: false,
    disableTutorial: false,
    disableDriveTypes: false,
    disableEngines: false,
    disableCapabilities: false,
    enableTrimFiltering: false,
  };

  switch (type) {
    case INIT_ROOT: {
      const { appResources } = payload;
      const lite = isLite(_.get(appResources, 'renderMode'));
      const enableTrimFiltering = _.get(
        appResources,
        'display.enableTrimFiltering',
        false
      );
      const disableCompareTrims = _.get(
        appResources,
        'display.disableTrimCompare',
        false
      );

      return {
        disableNotifications: lite,
        disablePostalCode: lite,
        disableInventorySummary: lite,
        disableCompareTrims,
        disableTutorial: lite,
        disableDriveTypes: lite,
        disableEngines: lite,
        disableCapabilities: lite,
        enableTrimFiltering,
      };
    }

    default:
      return state === undefined ? defaultRenderSettings : state;
  }
}
